<template>
  <div class="activity-main-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="activity-con" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <div class="activity-head" :style="{ 'padding-top': `${barHeight + 46 + 5}px` }">
        <div class="head-title">
          <MyPLabel
            class="head-title-txt"
            :str="$t('lang.activityA1.k003')"
            :numsOption="[{ value: 1200 || '', class: 'act-valentine-num' }]"
            :customClass="{ coin: 'act-valentine-coin' }"
          />
        </div>

        <div class="deal-tip">{{ $t('lang.activityA1.k002') }}</div>
        <div class="deal-line">
          <div class="timer">
            <img src="./images/clock.png" />
            <span class="time-num">
              <span>{{ countdownResult.days }}</span>
              <i>{{ $t('lang.commonM.k297') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.hours }}</span>
              <i>{{ $t('lang.commonM.k364') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.minutes }}</span>
              <i>{{ $t('lang.commonM.k365') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.seconds }}</span>
              <i>{{ $t('lang.commonM.k366') }}</i>
            </span>
          </div>
        </div>

        <div class="head-empty"></div>
      </div>

      <div class="main-con">
        <div class="part-block" style="margin-top: 0">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k208') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k419') }}</div>

          <div v-if="actInfo" class="points-rank">
            <div class="pr-item">
              <div>{{ $t('lang.commonM.k221') }}</div>
              <div v-if="actInfo">{{ actInfo.score || 0 }}</div>
              <img class="size1" src="./images/heart.png" />
            </div>
            <div class="pr-gap"></div>
            <div class="pr-item">
              <div>{{ $t('lang.commonM.k222') }}</div>
              <div v-if="actInfo">{{ actInfo.rank || '--' }}</div>
              <img class="size2" src="./images/rankbar.png" />
            </div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k218') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k420') }}</div>
          <div class="activity-reward">
            <div class="activity-item">
              <div class="reward-num">No.1</div>
              <div class="reward-coins">
                {{ boardData.num1Reward }}
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
            <div class="activity-item">
              <div class="reward-num">No.2</div>
              <div class="reward-coins">
                {{ boardData.num2Reward }}
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
            <div class="activity-item">
              <div class="reward-num">No.3</div>
              <div class="reward-coins">
                {{ boardData.num3Reward }}
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
            <div class="activity-item">
              <div class="reward-num">No.4-10</div>
              <div class="reward-coins">
                {{ boardData.num4Reward }}
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
          </div>

          <div class="btn-block">
            <div class="activity-btn" @click="handleToRank">{{ $t('lang.commonM.k220') }}</div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k435') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k436') }}</div>

          <!-- task-1 -->
          <!-- prettier-ignore -->
          <div v-if="actInfo && actInfo.signTask" class="task-item">
            <span class="task-item-tit">
              {{ $t('lang.commonM.k265') }}&nbsp;
              <span>{{ actInfo.signTask.proc }}</span>/<i>{{ actInfo.signTask.target }}</i>
            </span>
            <div class="task-item-reward">
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x1</div>
              </div>
            </div>
            <div v-if="actInfo.signTask.state === 0" class="task-item-btn pink" @click="handleSign">{{ $t('lang.commonM.k293') }}</div>
            <div v-if="actInfo.signTask.state === 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>

          <!-- task-2 -->
          <div v-if="actInfo && actInfo.call1Task" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">
              <MyPLabel :str="$t('lang.commonM.k437')" :numsOption="[{value: 1}]" />&nbsp;
              <span>{{ actInfo.call1Task.proc }}</span>/<i>{{ actInfo.call1Task.target }}</i>
            </span>
            <div class="task-item-reward">
              <!-- 头像框 -->
              <div v-if="packageName !== 'echo'" class="task-item-gift">
                <div class="item-gift-img"><img src="./images/avatar-bar.png" /></div>
                <div class="item-gift-num">x1</div>
              </div>

              <div v-if="packageName !== 'echo'" class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x1</div>
              </div>
            </div>

            <div v-if="actInfo.call1Task.state === 0" class="task-item-btn pink" @click="handleToChatList">
              <img src="./images/btn-arrow.png" />
            </div>
            <div v-if="actInfo.call1Task.state === 1" class="task-item-btn pink" @click="handleClaim(1)">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="actInfo.call1Task.state === 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>

          <!-- task-3 -->
          <div v-if="actInfo && actInfo.call3Task" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">
              <MyPLabel :str="$t('lang.commonM.k437')" :numsOption="[{value: 3}]" />&nbsp;
              <span>{{ actInfo.call3Task.proc }}</span>/<i>{{ actInfo.call3Task.target }}</i>
            </span>
            <div class="task-item-reward">
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('coupon')" /></div>
                <div class="item-gift-num">x1</div>
              </div>

              <div class="task-item-gap"></div>

              <!-- 头像框 -->
              <div v-if="packageName !== 'echo'" class="task-item-gift">
                <div class="item-gift-img"><img src="./images/avatar-bar.png" /></div>
                <div class="item-gift-num">x2</div>
              </div>

              <div v-if="packageName !== 'echo'" class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x2</div>
              </div>

              <div class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('coins')" /></div>
                <div class="item-gift-num">x10</div>
              </div>
            </div>

            <div v-if="actInfo.call3Task.state === 0" class="task-item-btn pink" @click="handleToChatList">
              <img src="./images/btn-arrow.png" />
            </div>
            <div v-if="actInfo.call3Task.state === 1" class="task-item-btn pink" @click="handleClaim(3)">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="actInfo.call3Task.state === 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>

          <!-- task-4 -->
          <div v-if="actInfo && actInfo.call5Task" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">
              <MyPLabel :str="$t('lang.commonM.k437')" :numsOption="[{value: 5}]" />&nbsp;
              <span>{{ actInfo.call5Task.proc }}</span>/<i>{{ actInfo.call5Task.target }}</i>
            </span>
            <div class="task-item-reward">
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('coupon')" /></div>
                <div class="item-gift-num">x1</div>
              </div>

              <div class="task-item-gap"></div>

              <!-- 头像框 -->
              <div v-if="packageName !== 'echo'" class="task-item-gift">
                <div class="item-gift-img"><img src="./images/avatar-bar.png" /></div>
                <div class="item-gift-num">x3</div>
              </div>

              <div v-if="packageName !== 'echo'" class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x3</div>
              </div>

              <div class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('coins')" /></div>
                <div class="item-gift-num">x25</div>
              </div>
            </div>

            <div v-if="actInfo.call5Task.state === 0" class="task-item-btn pink" @click="handleToChatList">
              <img src="./images/btn-arrow.png" />
            </div>
            <div v-if="actInfo.call5Task.state === 1" class="task-item-btn pink" @click="handleClaim(5)">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="actInfo.call5Task.state === 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>

          <!-- task-5 -->
          <div v-if="actInfo && actInfo.call10Task" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">
              <MyPLabel :str="$t('lang.commonM.k437')" :numsOption="[{value: 10}]" />&nbsp;
              <span>{{ actInfo.call10Task.proc }}</span>/<i>{{ actInfo.call10Task.target }}</i>
            </span>
            <div class="task-item-reward">
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('coupon')" /></div>
                <div class="item-gift-num">x2</div>
              </div>

              <div class="task-item-gap"></div>

              <!-- 头像框 -->
              <div v-if="packageName !== 'echo'" class="task-item-gift">
                <div class="item-gift-img"><img src="./images/avatar-bar.png" /></div>
                <div class="item-gift-num">x4</div>
              </div>

              <div v-if="packageName !== 'echo'" class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x4</div>
              </div>

              <div class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('coins')" /></div>
                <div class="item-gift-num">x40</div>
              </div>
            </div>

            <div v-if="actInfo.call10Task.state === 0" class="task-item-btn pink" @click="handleToChatList">
              <img src="./images/btn-arrow.png" />
            </div>
            <div v-if="actInfo.call10Task.state === 1" class="task-item-btn pink" @click="handleClaim(10)">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="actInfo.call10Task.state === 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>
        </div>

        <div v-if="showSuccess" class="act-mask">
          <div class="dia-bg">
            <div class="con-block">
              <div class="gifts-tit">
                <span>{{ $t('lang.commonM.k147') }}!</span>
              </div>
              <div v-if="showSuccess === 1" class="gifts">
                <div>
                  <div class="img-wrap img-big">
                    <img :src="getMatchImg('video-pass')" alt="" />
                  </div>
                  <div class="rewards-name">{{ $t('lang.commonM.k087') }}</div>
                  <div class="rewards-count">x1</div>
                </div>
              </div>

              <div v-if="showSuccess === 2" class="gifts">
                <div v-if="packageName !== 'echo'">
                  <div class="img-wrap">
                    <img src="./images/avatar-bar.png" alt="" />
                  </div>
                  <div class="rewards-name">{{ $t('lang.activityA1.k004') }}</div>
                  <div class="rewards-count">x1</div>
                </div>

                <div>
                  <div class="img-wrap">
                    <img :src="getMatchImg('video-pass')" alt="" />
                  </div>
                  <div class="rewards-name">{{ $t('lang.commonM.k087') }}</div>
                  <div class="rewards-count">x1</div>
                </div>
              </div>

              <template v-if="showSuccess === 3">
                <div class="gifts tworow" style="justify-content: space-around; margin-bottom: 0">
                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('coupon')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.giftSign.coupon') }}</div>
                    <div class="rewards-count">x1</div>
                  </div>

                  <div v-if="packageName !== 'echo'">
                    <div class="img-wrap">
                      <img src="./images/avatar-bar.png" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.activityA1.k004') }}</div>
                    <div class="rewards-count">x2</div>
                  </div>
                </div>

                <div class="gifts tworow" style="justify-content: space-around">
                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('video-pass')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.commonM.k087') }}</div>
                    <div class="rewards-count">x2</div>
                  </div>

                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('coins')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $rt('lang.base.coins') }}</div>
                    <div class="rewards-count">x10</div>
                  </div>
                </div>
              </template>

              <template v-if="showSuccess === 4">
                <div class="gifts tworow" style="justify-content: space-around; margin-bottom: 0">
                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('coupon')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.giftSign.coupon') }}</div>
                    <div class="rewards-count">x1</div>
                  </div>

                  <div v-if="packageName !== 'echo'">
                    <div class="img-wrap">
                      <img src="./images/avatar-bar.png" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.activityA1.k004') }}</div>
                    <div class="rewards-count">x3</div>
                  </div>
                </div>

                <div class="gifts tworow" style="justify-content: space-around">
                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('video-pass')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.commonM.k087') }}</div>
                    <div class="rewards-count">x3</div>
                  </div>

                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('coins')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $rt('lang.base.coins') }}</div>
                    <div class="rewards-count">x25</div>
                  </div>
                </div>
              </template>

              <template v-if="showSuccess === 5">
                <div class="gifts tworow" style="justify-content: space-around; margin-bottom: 0">
                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('coupon')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.giftSign.coupon') }}</div>
                    <div class="rewards-count">x2</div>
                  </div>

                  <div v-if="packageName !== 'echo'">
                    <div class="img-wrap">
                      <img src="./images/avatar-bar.png" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.activityA1.k004') }}</div>
                    <div class="rewards-count">x4</div>
                  </div>
                </div>

                <div class="gifts tworow" style="justify-content: space-around">
                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('video-pass')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.commonM.k087') }}</div>
                    <div class="rewards-count">x4</div>
                  </div>

                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('coins')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $rt('lang.base.coins') }}</div>
                    <div class="rewards-count">x40</div>
                  </div>
                </div>
              </template>

              <div class="gifts-confirm" @click="showSuccess = 0">
                <div>{{ $t('lang.ok') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { normalActBaseInfo, normalDaySign, normalDayClaim } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'
import CountDownClass from '@/utils/count-down.js'

export default {
  mixins: [countDown],
  data() {
    return {
      actInfo: null,
      packageName: '',
      boardData: {
        num1Reward: 1200,
        num2Reward: 800,
        num3Reward: 500,
        num4Reward: 100
      },
      leftClassObj: null,
      showSuccess: 0,
      loading: false
    }
  },
  methods: {
    handleToRule() {
      this.$router.push({ path: '/valentine-rules-male', query: { from: 'valentine-main-male' } })
    },
    handleToRank() {
      this.$router.push({ path: '/valentine-rank-male', query: { from: 'valentine-main-male' } })
    },
    handleReplaceToRank() {
      this.$router.replace({ path: '/valentine-rank-male' })
    },
    handleSign() {
      if (this.loading) {
        return
      }
      this.loading = true
      normalDaySign()
        .then((resData) => {
          if (resData && resData.data) {
            this.showSuccess = 1
            this.fetchData()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleToChatList() {
      this.appAction('open_session_page')
    },
    handleClaim(arg) {
      if (this.loading) {
        return
      }
      this.loading = true

      const idMap = {
        1: 2,
        3: 3,
        5: 4,
        10: 5
      }
      normalDayClaim(arg)
        .then((resData) => {
          if (resData && !resData.error) {
            this.showSuccess = idMap[arg]
            this.fetchData()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchData() {
      normalActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          this.actInfo = resData || null

          if (!this.actInfo) return

          if (this.actInfo.countdown <= 0) {
            this.handleReplaceToRank()
            return
          }

          // 初始化倒计时
          if (this.actInfo.endTimestamp) {
            this.initCountDown(this.actInfo.endTimestamp, true, true)
          }

          if (this.actInfo.dailyCountdown) {
            this.leftClassObj = new CountDownClass()
            this.leftClassObj.initCountDown(this.actInfo.dailyCountdown, 'HMS', false)
          }
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
.activity-main-root {
  width: 100%;
  min-height: 100vh;
  background: #e14364;

  .custom-nav-block {
    background: url(./images/main-bg.png) top left / 100% auto no-repeat;
  }

  .activity-con {
    .activity-head {
      width: 100%;
      min-height: 432px;
      padding-top: 25px;
      font-size: 0;
      position: relative;
      background: url(./images/main-bg.png) top left / 100% auto no-repeat;
      .head-title {
        width: 345px;
        margin: auto;

        .head-title-txt {
          color: #fff;
          text-align: center;
          text-shadow: 4px 3px 0 #ca2143, 2px 3px 0 #ca2143, 0 0 30px rgba(183, 17, 56, 0.65);
          font-family: 'Anton-Regular';
          font-size: 36px;
          font-style: normal;
          font-weight: bold;
          line-height: 120%;
        }
      }

      .deal-tip {
        width: 100%;
        margin-top: 60px;
        line-height: 28px;

        color: #fff;
        text-align: center;
        text-shadow: 2px 2px 0 #ca2143, 1px 2px 0 #ca2143, 0 0 10px rgba(183, 17, 56, 0.75);
        font-family: Antonio;
        font-size: 20px;
        font-weight: 400;
      }

      .deal-line {
        width: 100%;
        margin: 3px auto 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        .timer {
          min-width: 223px;
          height: 40px;
          padding: 0 24px;

          display: inline-flex;
          align-items: center;
          justify-content: center;

          border-radius: 40px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          background: linear-gradient(90deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 236, 239, 0.9) 50%, rgba(255, 255, 255, 0.9) 100%);
          backdrop-filter: blur(2px);
          img {
            width: 32px;
            height: 32px;
            margin: 0 3px;
          }
          > span {
            color: #f13157;
            font-family: 'TikTokSans-Regular';
            font-size: 20px;
            font-style: normal;
            font-weight: bold;
            line-height: 22px;
            display: flex;
            align-items: flex-end;
            i {
              font-size: 16px;
              line-height: 18px;
            }
          }
          .stp {
            padding: 0 2px;
          }
          .time-num {
            span {
              width: 26px;
              text-align: center;
            }
          }
        }
      }

      .head-empty {
        height: 110px;
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      padding-bottom: 79px;
      margin-top: -110px;

      .part-block {
        width: 355px;
        margin: 16px auto 0;
        padding-bottom: 24px;
        background: #fff5f9;
        border-radius: 12px;
        .part-head {
          width: 355px;
          line-height: 42px;
          background: #ff749b;
          border-radius: 12px 12px 0px 0px;
          text-align: center;
          span {
            color: #fff;
            font-family: 'TikTokSans-Regular';
            font-size: 17px;
            font-weight: bold;
          }
        }
        .part-tips {
          width: 100%;
          padding: 16px;
          font-family: TikTokSans-Regular;
          font-size: 15px;
          color: #dd173f;
          line-height: 22px;
          font-weight: normal;
        }

        .points-rank {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 16px;
          .pr-item {
            flex: 1;
            min-height: 66px;
            padding: 10px;
            background: #ffd9e0;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            position: relative;
            div:nth-child(1) {
              font-family: TikTokSans-Regular;
              font-weight: 400;
              font-size: 15px;
              color: #dd173f;
              line-height: 20px;
            }
            div:nth-child(2) {
              font-family: TikTokSans-Regular;
              font-weight: bold;
              font-size: 20px;
              color: #dd173f;
              max-width: calc(100% - 34px);
              word-wrap: break-word;
            }
            img {
              position: absolute;
              right: 5px;
              bottom: 0px;
            }
            img.size1 {
              width: 28px;
              height: 28px;
              bottom: 5px;
            }
            img.size2 {
              width: 40px;
              height: 40px;
            }
          }
          .pr-gap {
            width: 40px;
          }
        }

        .activity-reward {
          width: 100%;
          padding: 0 16px;
          min-height: 116px;
          margin: 0 auto;

          .activity-item {
            font-family: TikTokSans-Regular;
            font-weight: 400;
            font-size: 15px;
            color: #dd173f;
            line-height: 20px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            .reward-coins {
              display: flex;
              align-items: center;
              font-weight: bold;
              color: #dd173f;
              .coins-icon {
                width: 16px;
                height: 16px;
                margin-left: 4px;
              }
            }
          }
        }

        .task-item {
          padding: 0 16px;
          margin-bottom: 20px;
          position: relative;
          .task-item-tit {
            color: #dd173f;
            font-family: 'TikTokSans-Regular';
            font-size: 15px;
            display: flex;
            align-items: center;
            span {
              color: #dd173f;
            }
            i {
              color: #a4a9bd;
            }
          }
          .task-item-reward {
            margin-top: 6px;
            display: flex;
            align-items: center;
            .task-item-gap {
              width: 10px;
            }
            .task-item-gift {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .item-gift-img {
                border-radius: 6px;
                width: 38px;
                height: 38px;
                background: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: 30px;
                }
              }
              .item-gift-num {
                margin-top: 4px;
                color: #dd173f;
                font-family: 'TikTokSans-Regular';
                font-size: 12px;
                font-style: italic;
                font-weight: 700;
              }
            }
          }
          .task-item-btn {
            position: absolute;
            top: 50%;
            right: 16px;
            transform: translateY(-50%);
            text-align: center;
            font-family: 'TikTokSans-Regular';
            font-size: 16px;
            font-weight: 600;
            border-radius: 30px;
            min-width: 100px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 22px;
            }
          }
          .task-item-btn.pink {
            background: linear-gradient(93deg, #ff749b 5.83%, #ff4d7b 95.33%);
            color: #ffffff;
            font-weight: 400;
          }
          .task-item-btn.yellow {
            background: #ffb92a;
            color: #ffffff;
            font-weight: 400;
          }
          .task-item-btn.disable {
            background: #f2eded;
            color: #bda4a7;
            font-weight: 400;
          }
        }
      }
      .task-block {
        padding: 0 16px;
        .part-tips-b {
          font-family: TikTokSans-Regular;
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          margin-top: 32px;
          text-align: left;
        }
        .part-task {
          margin-top: 13px;
          font-family: TikTokSans-Regular;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
        }
      }

      .btn-block {
        display: block;
        width: 100%;
        margin: 30px auto 8px;
        text-align: center;
        .activity-btn {
          min-width: 275px;
          display: inline-block;
          padding: 10px 15px;
          border-radius: 30px;
          background: linear-gradient(93deg, #ff749b 5.83%, #ff4d7b 95.33%);
          font-family: TikTokSans-Regular;
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
          line-height: 26px;
          text-align: center;
          &.btn-disable {
            opacity: 0.4;
          }
        }
      }
    }
  }
}

.act-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dia-bg {
    width: 325px;
    border-radius: 16px;

    .con-block {
      width: 325px;
      padding-bottom: 30px;
      border-radius: 16px;
      background: linear-gradient(180deg, #fff5f9 27.09%, #ffdeeb 99.85%);

      .gifts-tit {
        background: url(./images/dialog-bg.png) left top / 100% auto no-repeat;
        padding: 25px 16px 21px;
        width: 100%;
        line-height: 20px;
        text-align: center;
        margin-bottom: 16px;

        span {
          color: #fafbff;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 20px;
          font-style: normal;
          font-weight: 900;
          line-height: normal;
        }
      }

      .gifts {
        width: 100%;
        padding: 12px 0;
        border-radius: 8px;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        & > div {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .img-wrap {
            width: 40px;
            height: 40px;
            padding: 5px;
            border-radius: 8px;
            border: 0.5px solid rgba(255, 255, 255, 0.5);
            background: #ffd9e0;
            img {
              width: 100%;
            }
            &.img-big {
              width: 60px;
              height: 60px;
            }
          }
          .rewards-name {
            font-family: TikTokSans-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #be2a32;
            line-height: 22px;
            margin-top: 4px;
            text-align: center;
            opacity: 0.9;
          }
          .rewards-count {
            font-family: TikTokSans-Regular;
            font-weight: bold;
            font-size: 17px;
            color: #be2a32;
            line-height: 22px;
            font-style: italic;
            opacity: 0.9;
            margin-top: 2px;
          }
        }
      }

      .tworow {
        padding: 12px 26px;
      }

      .gifts-confirm {
        width: 255px;
        margin: 0 auto;
        margin-top: 28px;
        padding: 10px;
        border-radius: 30px;
        background: #e14364;

        color: #fff;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px;
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .activity-main-root .activity-con .main-con .part-block .task-item .task-item-btn {
    right: unset;
    left: 16px;
  }
  .activity-main-root .activity-con .main-con .part-block .points-rank .pr-item img {
    right: unset;
    left: 5px;
  }
}
</style>

<style>
.act-valentine-num {
  font-size: 46px;
  line-height: 120%;
}
.act-valentine-coin {
  width: 40px;
  height: 40px;
}
</style>
